import { render, staticRenderFns } from "./SegDatosPostulante.vue?vue&type=template&id=2e737dce&scoped=true&"
import script from "./SegDatosPostulante.vue?vue&type=script&lang=js&"
export * from "./SegDatosPostulante.vue?vue&type=script&lang=js&"
import style0 from "./SegDatosPostulante.vue?vue&type=style&index=0&id=2e737dce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e737dce",
  null
  
)

export default component.exports